/** Build-time Meilisearch config baked into the bundle. */

export interface MeiliConfig {
  host: string;
  searchKey: string;
  indexName: string;
}

export function loadConfig(): MeiliConfig {
  const host = import.meta.env.VITE_MEILI_HOST as string | undefined;
  const searchKey = import.meta.env.VITE_MEILI_SEARCH_KEY as string | undefined;
  const indexName = (import.meta.env.VITE_MEILI_INDEX as string | undefined) ?? "scgb_content";

  if (!host || !searchKey) {
    throw new Error(
      "scgb-search: VITE_MEILI_HOST and VITE_MEILI_SEARCH_KEY must be set at build time"
    );
  }
  return { host, searchKey, indexName };
}
